import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, Overline } from "@/components/Sections";
import { IMAGES, ECOM_SITE } from "@/data";

const POINTS = [
  "Amazon DSP & Sponsored Ads managed end-to-end",
  "Listing, A+ content & storefront optimisation",
  "Marketplace scaling across India, US, UK & UAE",
  "TACoS-driven profitability, not just top-line GMV",
];

export default function AmazonSection() {
  return (
    <section id="ecommerce" className="py-24 md:py-36 bg-white border-y border-black/10" data-testid="ecommerce-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
        {/* Image with spotlight + clipped frame */}
        <Reveal className="order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-4 rounded-[2rem] bg-[#F48220]/10 blur-2xl" />
            <div className="relative overflow-hidden rounded-[1.75rem] border border-black/10">
              <img src={IMAGES.warehouse} alt="Ecommerce fulfilment" className="w-full h-[440px] object-cover" />
              <div className="absolute bottom-4 left-4 rounded-full bg-black/80 backdrop-blur px-4 py-2 font-body text-xs font-semibold text-white">
                amazonads.co.in
              </div>
            </div>
          </div>
        </Reveal>

        {/* Copy */}
        <div className="order-1 lg:order-2">
          <Reveal><Overline>Ecommerce & Marketplace</Overline></Reveal>
          <Reveal i={1}>
            <h2 className="mt-5 font-display text-4xl md:text-6xl font-extrabold tracking-tighter leading-[0.95] max-w-[15ch]">
              Win the <span className="text-[#F48220]">Buy Box.</span> Own the category.
            </h2>
          </Reveal>
          <Reveal i={2}>
            <p className="mt-6 font-body text-black/60 leading-relaxed max-w-[48ch]">
              Our dedicated ecommerce arm turns marketplaces into your most profitable channel —
              engineered by the same team that scaled brands like Vahdam across four countries.
            </p>
          </Reveal>
          <div className="mt-8 space-y-3">
            {POINTS.map((p, idx) => (
              <Reveal i={idx} key={p} className="flex items-center gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#E70D71]/12">
                  <Check className="h-3.5 w-3.5 text-[#E70D71]" />
                </span>
                <span className="font-body text-sm md:text-base text-black/75">{p}</span>
              </Reveal>
            ))}
          </div>
          <Reveal i={2}>
            <a
              href={ECOM_SITE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="ecommerce-cta-button"
              className="group mt-10 inline-flex items-center gap-3 rounded-full bg-[#3A53A3] pl-7 pr-3 py-3 text-white font-body font-semibold hover-lift"
            >
              Explore Ecommerce Services
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white transition-transform duration-500 group-hover:rotate-45">
                <ArrowUpRight className="h-5 w-5 text-[#3A53A3]" />
              </span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
